import { render, staticRenderFns } from "./PropertyManage.vue?vue&type=template&id=74ff5dd2"
import script from "./PropertyManage.vue?vue&type=script&lang=js"
export * from "./PropertyManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports